import { FORM_KEY_STREAMLINED_INSPECTION } from '@app/common/constants/forms'


const PDR_FORM = 'pdr'

export const isPdrOrStreamlinedInspectionOrder = (order) => {
  if (!order) {
    return false
  }
  return !!order.products?.find(product => (
    product?.included_forms?.includes(PDR_FORM) || product?.included_forms?.includes(FORM_KEY_STREAMLINED_INSPECTION)
  ))
}

export const isStreamlinedInspectionOrder = (order) => {
  if (!order) {
    return false
  }
  return !!order.products?.find(product => product?.included_forms?.includes(FORM_KEY_STREAMLINED_INSPECTION))
}
